<template>
    <router-link :to="link" class="card card--image">
        <div v-if="flags && member.countries" class="card__flags">
            <img
                v-for="(country, index) in member.countries"
                :src="country.flag"
                :key="index"
                alt=""
                v-tippy="country.name"
            />
        </div>
        <img v-if="member.logo" :src="`/images/logo/${member.id}`" alt="" />
    </router-link>
</template>

<script>
	export default {
		name: 'MemberCard',
		props: {
			member: {
				type: Object,
				required: true,
			},
			flags: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			link() {
				return { name: 'view-member', params: { id: this.member.id }};
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import '~reflex-grid/scss/includes/variables';
    @import '~reflex-grid/scss/includes/mixins';
    @import '~@/theme/_variables.scss';
    @import '~@/mixins/_class.scss';
    @import '~@/theme/_extenables.scss';

</style>

